import { Injectable } from '@angular/core';
import { GlobalsService } from '@services/global.service';
import AppConfiguration from '@hal.common.ui/utilities/AppConfig';
import { HttpResponse } from '@angular/common/http';
import { VenuesService as SDKVenuesService } from '@modules/SDKs/sysnetApi/api/venues.service';
import { GroupQuery, GroupSummaryQuery, VenueView } from '@modules/SDKs/sysnetApi';
import { ServicesWrappingSysnetSDK } from './ServicesWrappingSysnetSDK';

@Injectable({
    providedIn: 'root'
})
export class VenuesService extends ServicesWrappingSysnetSDK {
    private orgId: string;

    constructor(private sdkVenuesService: SDKVenuesService, private globals: GlobalsService) {
        super([sdkVenuesService], globals);
        this.globals.$state.subscribe((newState) => {
            if (newState) { this.orgId = newState.selectedOrganisation?._id; }
        });
    }

    // Get Venue
    public async getVenue(venueId: string): Promise<HttpResponse<VenueView>> {
        return this.sdkVenuesService.venuesIdGet(venueId as unknown as number, AppConfiguration.rsh.getStrVal('rid'), null, 'response').toPromise();
    }

    // Search Venues
    public async searchVenues(group?: GroupQuery, groupSummary?: GroupSummaryQuery, totalSummary?: GroupSummaryQuery,
                              sort?: string, limit?: number, offset?: number, search?: object, searchDistinct?: string): Promise<HttpResponse<VenueView[]>> {
        const searchCriteria = {
            ...search,
            organisationId: this.orgId
        };
        return this.sdkVenuesService.venuesGet(AppConfiguration.rsh.getStrVal('rid'), null,
        this.stringify(group), this.stringify(groupSummary), this.stringify(totalSummary), searchDistinct, sort, limit, offset, this.stringify(searchCriteria),
        null, null, null, null, null, null, null, null, null, null, 'response').toPromise();
    }

}
